module.exports = __webpack_public_path__ + "img/splash-screen-logo.5fcba62f.svg";